define('modules/CopyPaste/CopyPasteSearch',[
    'jquery',
    'global/all',
    '../Cart/all'
], function($, Roc, Cart) {
    'use strict';

    var apiUrl = window.RocConfig.api.baseRocApiUrl;
    var baseUrl;
    var viewModel = {};
    var listProducts = {};

    var forms = {
        Fields: [
        {
            "Name": 'Order',
            "Field": '#order',
            "Param": 'stringOrder',
            "Type": 'Text',
            "ErrorMsg": "Item numbers and quantities are missing"
        },
        {
            "Name": 'IdentifierType',
            "Field": '#identifierType',
            "Param": 'identifierType',
            "Type": 'Text'
        }],
        Validate: true,
        ErrorMsg: 'Item numbers and quantities are missing'
    }

    function validateForm(form) {
        var validationResult = true;
        
        if (typeof (form) === 'object' && form.Validate) {
            Roc.UI.clearFormErrors(form);

            _(form.Fields).forEach(function (f) {
                var $field = $(f.Field);
                if (!$field.val() || $field.val() === '') {
                    validationResult = false;
                    $(f.Field).focus();
                    Roc.UI.showFormFieldError(f);
                };
            });
            
            if (!validationResult) {
                Roc.UI.showFormErrorSummary(form);
            }
        }
        return validationResult;
    }

    function goToCart(response) {
        var data = {
            orderId: response.orderId,
            copyPasteProducts: response.copyPasteProducts,
            reportFile: response.reportFile,
            errorMessage: response.errorMessage
        }

        localStorage.setItem("CopyPasteResult", JSON.stringify(data));
        window.location.replace("/cart");
    }

    function cleanCartWarnings() {
        localStorage.removeItem("CopyPasteResult");
    }

    function loadAlert(orderCart) {
        var copyPasteResult = JSON.parse(localStorage.getItem("CopyPasteResult"));
        if (copyPasteResult && orderCart && copyPasteResult.orderId === orderCart.id && orderCart.items.length > 0) {

            var showAlert = false;
            $.each(orderCart.items, function(index, item) {
                var copyPasteItem = _.find(copyPasteResult.copyPasteProducts, { identifier: item.sku });
                if (copyPasteItem && (copyPasteItem.isDuplicate || copyPasteItem.isQtyRounded || copyPasteItem.isNotForSale || copyPasteItem.isCustom)) {
                        showAlert = true;
                }
            });

            if (showAlert) {
                var alertViewModel = {
                    errorMessage: copyPasteResult.errorMessage,
                    reportFile: {
                        fileName: 'Report.csv',
                        link: copyPasteResult.reportFile
                    }
                }
                Roc.UI.template('copyPasteAlert-Tmp', alertViewModel).then(function(renderedTemplate) {
                    $('#copyPasteAlertWrapper').html(renderedTemplate);
                });
            } else {
                $('#copyPasteAlertWrapper').html("");
            }
            
        } else {
            $('#copyPasteAlertWrapper').html("");
            cleanCartWarnings();
        }
    }

    function loadForm() {
        viewModel.placeHolder = "Q120,2 \r\nQ120 2";
        Roc.UI.template('copyPasteSearch-Tmp', viewModel).then(function (renderedTemplate) {
            $('#copyPasteSearchWrapper').html(renderedTemplate);
        });
    }

    function b64DecodeUnicode(str) {
        return decodeURIComponent(Array.prototype.map.call(atob(str), function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }

    function download(file, filename) {
        var uncoded = b64DecodeUnicode(file);
        var blob = new Blob([uncoded], { type: 'text/plain' });

        if (navigator.msSaveOrOpenBlob) {
            // Works for Internet Explorer and Microsoft Edge
            navigator.msSaveOrOpenBlob(blob, filename);
        } else {

            var a = document.createElement('a');
            a.download = filename;
            a.href = window.URL.createObjectURL(blob);
            a.textContent = 'Download ready';

            a.draggable = true;
            a.classList.add('dragout');

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    }

    function showValidationErrors(response) {
        var errorViewModel = {
            message: response.errorMessage,
            errors: []
        }
        $.each(response.copyPasteProducts, function (index, row) {
            $.each(row.errorMessages, function (index, error) {
                errorViewModel.errors.push({
                    error: 'Line ' + row.row + ' - ' + (row.rowData !== null ? row.rowData + ' - ' : '') + error
                });
            });
        });

        if (response.reportFile) {
            errorViewModel.reportFile = {
                fileName: 'Report.csv',
                link: 'data:application/octet-stream;charset=utf-8;base64,' + encodeURIComponent(response.reportFile)
            }
        }

        Roc.UI.template('copyPasteErrorSummary-Tmp', errorViewModel).then(function (renderedTemplate) {
            $('.errorWrapper').html(renderedTemplate);
        });

        Roc.UI.unblock("#copyPasteSearchWrapper");
    }

    function showReportModal(response) {

        if (response.showAddToCart) {
            Roc.UI.confirm({
                "title": 'Alert!',
                "message": response.errorMessage,
                "buttons": {
                    "Download": {
                        "class": 'btn',
                        "autoClose": false,
                        "action": function () {
                            getRepostFile(response.reportFile);
                        }
                    },
                    "Add To Cart": {
                        "class": 'btn',
                        "action": function () {
                            addToCart(true);
                        }
                    },
                    "Close": {
                        "class": 'btn',
                        "action": function () { }
                    }
                }
            });
        } else {
            Roc.UI.confirm({
                "title": 'Alert!',
                "message": response.errorMessage,
                "buttons": {
                    "Download": {
                        "class": 'btn',
                        "autoClose": false,
                        "action": function () {
                            getRepostFile(response.reportFile);
                        }
                    },
                    "Close": {
                        "class": 'btn',
                        "action": function () { }
                    }
                }
            });
        }

        
        Roc.UI.unblock("#copyPasteSearchWrapper");
    }

    function showCartMessages(response) {
        var messages = "";
        _.each(response.addCartItemsResponse, function (item) {
            if (!item.message) {
                messages += "<p>" + item.message + "</p>";
            }
        });

        if (messages !== "") {
            Roc.UI.confirm({
                "title": 'Information',
                "message": messages,
                "buttons": {
                    "Ok": {
                        "class": 'btn',
                        "action": function () {
                            listProducts = response;
                            goToCart(response);
                            Roc.EventManager.notify(Roc.Events.cart.ADD_ITEM, response);
                        }
                    }
                }
            });
            Roc.UI.unblock("#copyPasteSearchWrapper");
            return false;
        }
        return true;
    }

    function getRepostFile(fileName) {
        $.ajax({
            type: 'GET',
            url: apiUrl + '/api/copypaste/reportfile/' + fileName,
            dataType: 'json',
            timeout: 300000,
            complete: function(xhr) {
                var response = xhr.responseJSON;
                if (xhr.status === 200) {
                    download(response.file, response.fileName);
                } else {
                    Roc.UI.error(response && response.message
                        ? response.message : "There was an error while trying to get report file. Please try again later.");
                }
            }
        });
    }

    function addToCart(isAccepted) {
        $('.errorWrapper').html('');
        Cart.CartSummary.init({
            showAddToCartModal: false
        });
        
        if (validateForm(forms)) {
            Roc.UI.block("#copyPasteSearchWrapper");
            var request = Roc.Forms.getFormValues(forms);
            request.orderId = '{orderId}';
            request.isAccepted = isAccepted === true;
            viewModel.list = request.stringOrder;
            $.proxyRequest({
                type: 'POST',
                url: '/api/copypaste/addProductToCart',
                data: JSON.stringify(request),
                dataType: 'json',
                timeout: 300000,
                complete: function (xhr) {

                    Roc.Logger.info(xhr);
                    var response = xhr.responseJSON || {};
                    if (!response.isValid && !response.message && !response.isAccepted) {
                        showValidationErrors(response);
                        return false;
                    } else if (response.message) {
                        Roc.UI.ajaxErrorPopup(xhr);
                        return false;
                    } else if (response.errorMessage !== null && response.errorMessage !== undefined && !response.isAccepted) {
                        showReportModal(response);
                        return false;
                    }

                    if (!showCartMessages(response)) {
                        return false;
                    }

                    listProducts = response;
                    goToCart(response);
                    Roc.EventManager.notify(Roc.Events.cart.ADD_ITEM, xhr);
                },
                error: function() {
                    Roc.UI.unblock("#copyPasteSearchWrapper");
                }
            });
        } 
    }

    function submitFormEvt() {
        $(document).on('click', '.submit', function () {
            addToCart();
        });
    }

    function downloadRepostEvt() {
        $(document).on('click', '.downloadBtn', function () {
            var copyPasteResult = JSON.parse(localStorage.getItem("CopyPasteResult"));
            if (copyPasteResult !== undefined && copyPasteResult !== null) {
                getRepostFile(copyPasteResult.reportFile);
            }
        });
    }

    function setIdentifiers(options) {
        viewModel.identifiers = [];
        $.each(options.identifiers, function(key, value) {
            viewModel.identifiers.push({ key: key, value: value });
        });
    }

    function bindEvents(callbacks) {
        Roc.EventManager.bind(Roc.Events.cart.CART_WAS_RELOAD, loadAlert);
        Roc.EventManager.bind(Roc.Events.cart.CART_SAVED, cleanCartWarnings);
        Roc.EventManager.bind(Roc.Events.cart.PAGE_LOAD, loadAlert);
        submitFormEvt(null);
        downloadRepostEvt();
    }

    function initCart(model) {
        bindEvents();
    }

    function init(options) {
        baseUrl = options.baseUrl;
        setIdentifiers(options);
        bindEvents();
        loadForm();
    };

    var CopyPasteSearch = {
        init: init,
        initCart: initCart,
        order: viewModel,
        cleanCartWarnings: cleanCartWarnings
    };

    return CopyPasteSearch;
});
